import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";
import i18n from "i18next";
import { LuX } from "react-icons/lu";
import IdealStudio from "../../../../../core/editor/main";
import { isClmAllowedPlugin } from "../../../../../common/clm";
import { addPluginBox } from "../elementActions";
import AssetGrid from "../ui/AssetGrid";
import AssetCell from "../ui/AssetCell";
import BetaTag from "../../../common/BetaTag.jsx";
import ElementPreview from "./ElementPreview";
import "./_panel.scss";
import "./_elementsPanel.scss";

const CLICK_MENU_NAMES = ["OneClick", "GuideMultiInput", "GuideTagDisplay"];

const BETA_NAMES = ["GuideMultiInput", "GuideTagDisplay"];

const ClickMenuPanel = (props) => {
  const {
    boxes,
    boxSelected,
    navItems,
    navItemSelected,
    containedViews,
    containedViewSelected,
    onBoxAdded,
    onClose,
    isClm,
  } = props;

  const [buttons, setButtons] = useState([]);

  useEffect(() => {
    const byName = {};
    (IdealStudio.Plugins.getPluginConfigs() || []).forEach((cfg) => {
      byName[cfg.name] = cfg;
    });
    // CLM: GuideMultiInput/GuideTagDisplay are not exportable — OneClick only.
    setButtons(
      CLICK_MENU_NAMES.filter((name) => !isClm || isClmAllowedPlugin(name))
        .map((name) => byName[name])
        .filter(Boolean)
    );
  }, [isClm]);

  const ctx = {
    boxes,
    boxSelected,
    navItems,
    navItemSelected,
    containedViews,
    containedViewSelected,
    onBoxAdded,
  };

  const renderCard = (cfg) => {
    const label = i18n.t(`PluginNames_${cfg.name}`, { defaultValue: cfg.name });
    return (
      <AssetCell
        key={cfg.name}
        dragProps={{
          className: "palette-item floatingEditorBox",
          name: cfg.name,
          "data-plugin": cfg.name,
          "data-schematic": "1",
        }}
        ratio={0.82}
        title={label}
        label={label}
        onAdd={(e) => addPluginBox(cfg.name, e, ctx)}
        badge={BETA_NAMES.includes(cfg.name) ? <BetaTag /> : undefined}
      >
        <ElementPreview kind={cfg.name} icon={cfg.icon} />
      </AssetCell>
    );
  };

  return (
    <div className="cmp-panel">
      <div className="cmp-panel__toolbar">
        <span className="cmp-panel__title">{i18n.t("click_menu") || "Tıklama Menüsü"}</span>
        {onClose && (
          <button
            type="button"
            className="cmp-panel__close"
            onClick={onClose}
            title={i18n.t("close")}
          >
            <LuX size={15} />
          </button>
        )}
      </div>

      <div className="cmp-panel__scroll">
        <div className="cmp-el-list">
          <div className="cmp-el-group">
            <AssetGrid columns={2} cellSize={118} gap={10}>
              {buttons.map(renderCard)}
            </AssetGrid>
          </div>
        </div>
      </div>
    </div>
  );
};

ClickMenuPanel.propTypes = {
  boxes: PropTypes.object.isRequired,
  boxSelected: PropTypes.any,
  navItems: PropTypes.object.isRequired,
  navItemSelected: PropTypes.any.isRequired,
  containedViews: PropTypes.object.isRequired,
  containedViewSelected: PropTypes.any.isRequired,
  onBoxAdded: PropTypes.func.isRequired,
  onClose: PropTypes.func,
  isClm: PropTypes.bool,
};

export default ClickMenuPanel;
